import { format, parseISO } from 'date-fns'

export const dateToday = format(new Date(), 'yyyy-MM-dd')
export const dateTimeToday = format(new Date(), "yyyy-MM-dd'T'HH':'mm':'ss")
export const timestamp = () => format(new Date(), "yyyy-MM-dd'T'HH':'mm':'ss")
export const timestampFileSystemCompatible = () => format(new Date(), "yyyy-MM-dd'_'HH'-'mm'-'ss")

export const dateParse = (dateString) => {
  if (!dateString) return ''
  return format(parseISO(dateString), "yyyy-MM-dd' 'HH':'mm':'ss")
}

export const dateParseJustDate = (dateString) => {
  if (!dateString) return ''
  return format(parseISO(dateString), "yyyy-MM-dd'")
}

const fixInlineImages = (HTMLstr) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(HTMLstr, 'text/html')
  const h4s = doc.querySelectorAll('h4')
  h4s.forEach((h4) => {
    const parent = h4.parentNode
    const img = h4.querySelectorAll('img')
    if (parent && img.length) parent.insertBefore(img[0], h4)
  })
  return doc.body.innerHTML
}

export const cleanOutHTML = (HTMLstr) => {
  let cleanedHTML = HTMLstr
  const regexPattern = /<p\b[^<>\/]*>\s*(<img\b[^<>]*>)\s*<\/p>/g // Removed <p></p> round images.
  cleanedHTML = cleanedHTML.replace(regexPattern, '$1')
  cleanedHTML = fixInlineImages(cleanedHTML)
  return cleanedHTML
}

export const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

export const getImageDimensions = (file) =>
  new Promise((resolve, reject) => {
    var url = URL.createObjectURL(file)
    var img = new Image()

    img.onload = function () {
      resolve({ width: img.width, height: img.height })
      URL.revokeObjectURL(img.src)
    }
    img.onerror = function () {
      reject()
    }
    img.src = url
  })

export const getFileExtension = (fileName) => {
  const ext = fileName.split('.').pop()
  return ext === 'jpeg' ? 'jpg' : ext
}

export function debounce(fn, wait){
  let timer;
 return function(...args){
   if(timer) {
      clearTimeout(timer); // clear any pre-existing timer
   }
   const context = this; // get the current context
   timer = setTimeout(()=>{
      fn.apply(context, args); // call the function if time expires
   }, wait);
 }
}